import angular from 'angular';
import otherDirectCostsComponent from './other-direct-costs.component';

let otherDirectCostsModule = angular.module('otherDirectCosts', [])
  .component('otherDirectCosts', otherDirectCostsComponent);

export default otherDirectCostsModule;



// WEBPACK FOOTER //
// ./client/pages/expenses/other-direct-costs/other-direct-costs.js